module.exports = __webpack_public_path__ + "img/img_cx5_open.8338977d.jpg";